import React from 'react';
import './PickerContainer.scss';
import { usePickerContext } from '../../picker/hooks/usePickerContext';

export function PickerContainer({ loading, rightWidth, className, description, ...props }) {

    const {state} = usePickerContext()

    const getComponentByKey = (key) => props.children.filter(child => child.key === key)[0] || null;
    const hasCenter = getComponentByKey('center') !== null;
    return (
        <div {...props} className={'PickerContainer ' + className}>
            {hasCenter &&
                <section className={'PickerContainer-left'}>{ getComponentByKey('left') }</section>
            }
            <section className={'PickerContainer-map'}>
                {state.device !== "phone" && (
                    <header className="PickerContainer-sectionHeader PickerContainer-mapHeader">
                        <span className={'PickerContainer-title'}>Plan de la salle :</span>
                        <span className={'PickerContainer-info'}>{description ? description : "Cliquez sur les places ou plusieurs fois dans la zone que vous souhaitez, puis sélectionnez vos tarifs dans l'écran de droite."}</span>
                    </header>
                )}
                <main className="PickerContainer-sectionMain PickerContainer-mapMain">
                    { getComponentByKey(hasCenter ? 'center' : 'left') }
                </main>
            </section>
            <section className={'PickerContainer-tickets'} style={{ width: rightWidth, maxWidth: rightWidth }}>{ getComponentByKey('right') }</section>
        </div>
    )
}